import { useShallow } from 'zustand/react/shallow';

import { Button } from '#/shared/components/Button';
import { Modal, ModalContent } from '#/shared/components/Modal';
import { usePaidBreakExceptionStore } from '#/shared/stores/paidBreakExceptionStore';
import { formatDurationToHours } from '#/shared/utils/dateTimeHelper';

export interface AcceptAllModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function AcceptAllModal({ isOpen, onClose }: Readonly<AcceptAllModalProps>) {
  const acceptAllExceptions = usePaidBreakExceptionStore(s => s.acceptAllExceptions);
  const totalBreak = usePaidBreakExceptionStore(useShallow(s => s.getTotalExceptionsBreak()));
  const totalBreakHours = formatDurationToHours(totalBreak);

  const handleConfirm = () => {
    acceptAllExceptions();
    onClose();
  };

  return (
    <Modal isOpen={isOpen}>
      <ModalContent title={'Accept all paid break exception requests?'} onCancel={onClose}>
        {/* "overflow-y-auto" so the middle section scrolls */}
        <div className="px-24 pb-4 flex flex-col gap-16 overflow-y-auto">
          <p>
            If accepted, the timesheet will adjust to{' '}
            <strong className="font-700">add {totalBreakHours} hour(s) total of ordinary time.</strong>
          </p>
          <p>You will still be able to accept or reject individual requests before approving the timesheet.</p>
        </div>

        <div className="px-24 flex gap-12">
          <Button variant="primaryOutline" size="medium" onPress={onClose} className="w-full">
            Cancel
          </Button>
          <Button size="medium" className="w-full" onPress={handleConfirm}>
            Accept all requests
          </Button>
        </div>
      </ModalContent>
    </Modal>
  );
}
